export default function onEnter() {
  return function link(scope, element, attrs) {
    element.bind('keypress', (event) => {
      if (event.which === 13 && event.shiftKey === false) {
        scope.$apply(() => {
          scope.$eval(attrs.onEnter);
        });

        event.preventDefault();
      }
    });
  };
}
